/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../widgets/livewidget/query/CommonQueryHelper',
	'./QueryDefinition',
	'./api/QueryService2API'
], (APIFactory, CommonQueryHelper, QueryDefinition, QueryServiceAPI2) => {
	class QueryService2 extends CommonQueryHelper{

		constructor(options) {
			const internalQueryService = options.features['QueryService.internal'];
			super({
				queryService: internalQueryService
			}, options.features['Logger']);
			this.dashboard = options.features['API'];
			this.internalQueryService = internalQueryService;
			this.queryClasses = {};
		}

		getAPI() {
			if (!this.queryServiceAPI) {
				this.queryServiceAPI = APIFactory.createAPI(this, [QueryServiceAPI2]);
			}
			return this.queryServiceAPI;
		}

		registerQueryClass(queryProtocol, QueryClass) {
			if(this.queryClasses[queryProtocol]) {
				throw new Error(`There is already a query class registered for ${queryProtocol}`);
			}
			this.queryClasses[queryProtocol] = QueryClass;
		}

		createQueryDefinition(id, type) {
			return new QueryDefinition({ id, type }).getAPI();
		}

		_getProtocol(definitionList) {
			const datasource = definitionList && definitionList.length > 0 ? definitionList[0].getDataSource() : null;
			return datasource && datasource.getProtocol();
		}

		createQuery(definitionList) {
			const queryProtocol = this._getProtocol(definitionList);
			const QueryClass = this.queryClasses[queryProtocol];
			if (QueryClass) {
				return new QueryClass({
					dashboard: this.dashboard,
					internalQueryService: this.internalQueryService,
					definitionList
				});
			} else  {
				throw new Error(`Query class is not registered for ${queryProtocol}`);
			}
		}
	}

	return QueryService2;
});
